import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface FloatingCtaProps {
  onClick: () => void;
  price: string;
  originalPrice?: string;
  label?: string;
  showAfter?: number;
}
export function FloatingCta({
  onClick,
  price,
  originalPrice,
  label = 'ACTIVA TU ACCESO',
  showAfter = 600
}: FloatingCtaProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > showAfter);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [showAfter]);
  return <AnimatePresence data-id="element-8">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.35,
      ease: [0.16, 1, 0.3, 1]
    }} className="fixed bottom-0 inset-x-0 z-40 pb-4 sm:pb-6 px-4 pointer-events-none" data-id="element-9">
          <div className="max-w-2xl mx-auto pointer-events-auto" data-id="element-10">
            <div className="bg-black/80 backdrop-blur-2xl border border-white/15 rounded-2xl shadow-2xl shadow-black/60 p-3 sm:p-4 flex items-center gap-3 sm:gap-4 pr-20 sm:pr-24" data-id="element-11">
              {/* Price */}
              <div className="flex flex-col items-start min-w-0 pl-1" data-id="element-12">
                <span className="text-[10px] sm:text-xs uppercase tracking-widest text-emerald-400 font-semibold" data-id="element-13">
                  Hoy Solo
                </span>
                <div className="flex items-baseline gap-2" data-id="element-14">
                  <span className="text-xl sm:text-2xl font-bold text-white tabular-nums" data-id="element-15">
                    {price}
                  </span>
                  {originalPrice && <span className="text-xs sm:text-sm text-white/40 line-through tabular-nums" data-id="element-16">
                      {originalPrice}
                    </span>}
                </div>
              </div>

              {/* CTA */}
              <button onClick={onClick} className="ml-auto flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-400 active:bg-emerald-600 text-white font-bold text-sm sm:text-base px-4 sm:px-6 py-3 sm:py-4 rounded-xl shadow-[0_0_30px_-8px_rgba(16,185,129,0.6)] ring-1 ring-emerald-400/40 transition-all duration-200 whitespace-nowrap" data-id="element-17">
                {label}
                <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-18" />
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}